<template lang="html">
  <my360FormGroup>
    <label
      v-if="label"
      :for="prop">
      {{ label }}
    </label>
    <input
      ref="input"
      v-model="propPath"
      v-bind="attributes"
      :validationName="validationName"
      :prop="prop"
      :name="attributes.name ? attributes.name : prop"
      :class="classNames">
    <div
      v-if="hasKey(errorBag, prop)"
      class="invalid-feedback">
      <i class="far fa-times-circle" />
      {{ getErrorMessage }}
    </div>
  </my360FormGroup>
</template>
<script>
import inputType from '../../mixins/inputType'

export default {
  name: 'My360Input',

  mixins: [inputType],

  computed: {
    defaultAttributes () {
      return {
        type: 'text'
      }
    }
  },

  mounted () {
    console.log(this.errorBag)
    // && isDirty || hasKey(errorBag, prop) && Object.keys(my360FormErrors) > 0
  }
}
</script>
